import * as React from 'react';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, IconButton, Modal, Typography } from '@mui/material';
import { useSpring, animated } from '@react-spring/web';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import Image from 'mui-image';
import CloseIcon from '@mui/icons-material/Close';

const Fade = React.forwardRef(function Fade(props, ref) {
    const {
        children,
        in: open,
        onClick,
        onEnter,
        onExited,
        ownerState,
        ...other
    } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter(null, true);
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited(null, true);
            }
        },
    });

    return (
        <animated.div ref={ref} style={style} {...other}>
            {React.cloneElement(children, { onClick })}
        </animated.div>
    );
});

Fade.propTypes = {
    children: PropTypes.element.isRequired,
    in: PropTypes.bool,
    onClick: PropTypes.any,
    onEnter: PropTypes.func,
    onExited: PropTypes.func,
    ownerState: PropTypes.any,
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "100%",
    height: "100vh",
    bgcolor: '#282A3A',
    border: "1px solid gold",
    boxShadow: 24,
    p: 4,
    color: "white"
};
export default function HamMenu(props) {
    var open = props.open;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClose = () => {
        props.setOpen();
    };
    return (
        <div>
            <Modal className='no-overflow'
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
                aria-labelledby="about-me"
                align="center"
                sx={{ maxHeight: "100vh" }}
            >
                <Fade in={open}>
                    <Box sx={style} className='no-overflow'>
                        <IconButton sx={{
                            position: "relative",
                            float: "right",
                            background: "transparent",
                            color: "white",
                            top: "-10px",
                            right: "-10px",
                            fontSize:"1rem",
                            borderRadius:50,
                            width:"fit-content",
                            height:"fit-content",
                        }} onClick={handleClose}>
                            <CloseIcon></CloseIcon>
                        </IconButton>

                        <Grid className='no-overflow' container spacing={2} direction="row" justifyContent="center" alignItems="center" maxHeight="100vh" minHeight="75vh" id="work" >
                            <Grid className='no-overflow' item width="100%" textAlign="left">
                                <Box sx={{ flexGrow: 1, display: { xs: 'block', md:"none", lg: 'none' }, justifyContent: "right" }}>
                                    {props.pages.map((page) => (
                                        <Button href={page.linkRef} onClick={handleClose}
                                            key={page.title}
                                            sx={{ my: 2, color: 'white', display: 'block', mr: 3, ml: 3, padding: 1}}
                                        ><Typography
                                            noWrap
                                            sx={{
                                                display: { xs: 'block', md:"none", lg: 'none' },
                                                fontFamily: 'Title',
                                                // fontSize:20,
                                                // fontWeight: 700,
                                                letterSpacing: '.2rem',
                                                color: 'inherit',
                                                textDecoration: 'none',
                                                textAlign: "center",
                                                textTransform: "capitalize"
                                            }}
                                        >
                                                {page.title}
                                            </Typography>
                                        </Button>
                                    ))}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}